import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import PasswordlessSignIn from '../PasswordlessSignIn';

const ProtectedRoute = ({ 
  children, 
  title, 
  loadingComponent = null,
  requireAuth = true 
}) => {
  const { user, loading, loggedIn } = useAuth();

  // Show loading state while auth is being determined
  if (loading) {
    return loadingComponent || (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '1.1rem',
        color: '#666'
      }}>
        Verifying access...
      </div>
    );
  }

  // If authentication is required but user is not logged in
  if (requireAuth && !loggedIn) {
    return (
      <PasswordlessSignIn 
        title={title}
        onSuccess={() => {
          // The AuthContext will handle the state change
          // and this component will re-render with the authenticated user
        }}
      />
    );
  }

  // User is authenticated or auth is not required, render the protected content
  return children;
};

export default ProtectedRoute;
